import { postRequest } from '@/core';
import { edi } from '@/requests';
export default async function(ediSetup) {
	let url = edi.manualImportPath(ediSetup.edipartId);
	let response = await postRequest(url, '', ediSetup);
	return response;
}